"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARE_MODES = {
    CHANNEL: 'channel',
    VIDEO: 'video',
};
//# sourceMappingURL=constants.js.map